import Axios from "axios";

export const uploadFileToS3 = ({ file, url, fileType }, onProgress, next) => {
    return async (dispatch) => {
      
      try {
        await Axios.put(url, file.originFileObj, {
          headers: {
            'Content-Type': fileType,
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            onProgress(percent);
          },
        });
        next(true); // Success
      } catch (error) {
        console.error("Upload error:", error);
        next(false); // Failed
      }
    };
  };